// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_authentication_authentication_routes_ts":"1e87277e0805e29a","node_modules_angular_animations_fesm2022_browser_mjs":"92ebb2f136df3db4"}[chunkId] + ".js";
};